import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { WDropdownComponent } from '@wipo/w-angular/w-dropdown';
import { Subscription } from 'rxjs';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'li[w-table-command-link],li[w-table-command-link-end]',
    templateUrl: './w-table-command-link.component.html',
    /** if there is no drawer under preceding A element,
     * we have no dropdown or
     * we are using w-dropdown that has its own arrow,
     * hence we hide it here */
    styles: [
        `a:not(:has(w-drawer)) + .b-pointer__arrow  {
      display: none !important;
    }`
    ],
    host: {
        class: 'b-workbench-commands__item',
        '[class.b-pointer]': 'pointerDropdown',
        '[class.b-workbench-commands__link_no_caret]': 'hideDropdownCaret'
    },
    standalone: false
})
/*
@id w-table-command-link
@name w-table-command-link
@status release
@description
*/
export class WTableCommandLinkComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('dd') dropdown?: WDropdownComponent;
  @Input('pointer') pointerDropdown: boolean = false; // manually indicate the selection state
  @Input() hideDropdownCaret = false; // hide dropdown caret for a particular link (when parent has dropdowns=true)
  get pointer() {
    return this.pointerDropdown;
  }
  @Input() link?: string; // browser link
  @Input() routerLink?: string; // Angular router link

  // emit from outside
  @Output() wSelected = new EventEmitter<any>();
  // emit from child dropdown
  wAction = this.wSelected;

  hasDirectText = false;

  private get element(): HTMLElement {
    return this.elRef.nativeElement;
  }
  private _action: Subscription | undefined; // action subscription, used to toggle pointerDropdown
  constructor(public elRef: ElementRef) { }
  ngOnDestroy(): void {
    this._action?.unsubscribe();
  }
  ngOnChanges(changes: SimpleChanges): void {
    const pointerDropdown = changes['pointerDropdown'];
    if (pointerDropdown?.currentValue !== pointerDropdown?.previousValue) {
      /** if we use explicit external pointer, stop toggle from wSelect */
      this._action?.unsubscribe();
      this._action = undefined;
    }
  }
  ngOnInit(): void {
    this._action = this.wAction.subscribe((x) => {
      this.pointerDropdown = !this.pointerDropdown;
    })
  }

  ngAfterViewInit() {
/** 
 * this calculates condition when to add SPAN node used by :after selector to add dropdown caret 
 * used for table-commands component with the "dropdown" flag
 * it does not support dynamic adding of text
 * we can have text node directly in LI element or indirectly in A 
 * if component contains complex structures dropdown caret might not display correctly
 * */
    setTimeout(() => {
      this.hasDirectText = this.nodeHasDirectText(this.element) || Array.from(this.element.childNodes)
        .some(node => node.nodeType === Node.ELEMENT_NODE && (node as HTMLElement).tagName === 'A' && this.nodeHasDirectText(node as HTMLElement));
    });
  }
  private nodeHasDirectText(element: HTMLElement) {
    return Array.from(element.childNodes)
      .some(node => node.nodeType === Node.TEXT_NODE && node.textContent && node.textContent.trim().length > 0);
  }
}
